import { NgModule } from '@angular/core'
import { MbFloatingLabelDirective } from './directives/mb-floating-label.directive'
import { MbOpenLinkInNewTabDirective } from './directives/mb-open-link-in-new-tab.directive'
import { MbShowPopupDirective } from './directives/mb-show-popup.directive'
import { MbTextareaAutoresizeDirective } from './directives/mb-textarea-autoresize.directive'
import { MbOneClickAllowedDirective } from './directives/mb-one-click-allowed.directive'
import { MbCopyToClipboardDirective } from './directives/mb-copy-to-clipboard.directive'
import { MbFocusDirective } from './directives/mb-focus.directive'

@NgModule({
  imports: [],
  declarations: [
    MbFloatingLabelDirective,
    MbOpenLinkInNewTabDirective,
    MbShowPopupDirective,
    MbTextareaAutoresizeDirective,
    MbOneClickAllowedDirective,
    MbCopyToClipboardDirective,
    MbFocusDirective
  ],
  exports: [
    MbFloatingLabelDirective,
    MbOpenLinkInNewTabDirective,
    MbShowPopupDirective,
    MbTextareaAutoresizeDirective,
    MbOneClickAllowedDirective,
    MbCopyToClipboardDirective,
    MbFocusDirective
  ]
})
export class DirectiveModule {}
